var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 361,
    viewBox: "0 0 390 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_77",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 361
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 180,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_2",
    x: 210,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_3",
    x: 240,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_4",
    x: 270,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_5",
    x: 300,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_6",
    x: 330,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_7",
    x: 360,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_8",
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_9",
    x: 30,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_10",
    x: 60,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_11",
    x: 90,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_12",
    x: 120,
    width: 10,
    height: 361,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4_13",
    x: 150,
    width: 10,
    height: 361,
    fill: "black"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 185,
    cy: 181,
    r: 150,
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSmall);
export default __webpack_public_path__ + "static/media/circle_small.439fa4f3653e3b45e9488e411af75e83.svg";
export { ForwardRef as ReactComponent };